import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";
import { LinkedinFeedPeriod } from "@/app/types/prospect/LinkedinFeedPeriod";

const PERIOD_LABELS: Record<LinkedinFeedPeriod, TKey> = {
  [LinkedinFeedPeriod.PAST_24H]: TKey.PROSPECT_FEED_PERIOD_24H,
  [LinkedinFeedPeriod.PAST_WEEK]: TKey.PROSPECT_FEED_PERIOD_WEEK,
  [LinkedinFeedPeriod.PAST_MONTH]: TKey.PROSPECT_FEED_PERIOD_MONTH,
};

export function feedPeriodOptions(t: TFn): { period: LinkedinFeedPeriod; label: string }[] {
  return Object.values(LinkedinFeedPeriod).map((period) => ({
    period,
    label: t(PERIOD_LABELS[period]),
  }));
}

export function feedOpenLabel(t: TFn, memberCount: number): string {
  return `${t(TKey.PROSPECT_FEED_OPEN)} (${memberCount})`;
}

export function feedNoticeLabel(
  t: TFn,
  totalMemberCount: number,
  prospectCount: number,
  cap: number,
): string | null {
  if (prospectCount > cap) {
    return t(TKey.PROSPECT_FEED_CAPPED).replace("{{n}}", String(cap));
  }

  const missing = prospectCount - totalMemberCount;

  return missing > 0 ? t(TKey.PROSPECT_FEED_MISSING).replace("{{n}}", String(missing)) : null;
}
